<template>
  <div>
    <Containers
      v-if="hasPermission('nodes.types.view')"
      class="mb-2"
    />

    <Networks
      v-if="hasPermission('nodes.types.view')"
      class="mb-2"
    />
    <Components
      v-if="hasPermission('nodes.types.view')"
      class="mb-2"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Containers from '@/views/admin/advancedConfiguration/nodes/Containers';
import Networks from '@/views/admin/advancedConfiguration/nodes/Networks';
import Components from '@/views/admin/advancedConfiguration/nodes/Components';

export default {
    components: {
        Containers,
        Networks,
        Components,
    },
    computed: {
        ...mapGetters(['hasPermission']),
    },
    created() {
        this.$store.dispatch('clearTabs'); // Delete steps footer on the modal
    },
};
</script>
